import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const contains = (field: string, query: string) => {
    return `contains(toLowerCase(${field}), "${query.toLowerCase()}")`;
};

const and = (...args: string[]) => {
    return args.join(' && ');
};

const or = (...args: string[]) => {
    return '(' + args.join(' || ') + ')';
};

const buildFilterString = (query: string, showInactive: boolean) => {
    const substringSearch = or(
        contains('visitorId', query),
        contains('metadata.agent.email', query),
        contains('metadata.agent.full_name', query),
    );

    return showInactive
        ? substringSearch
        : and(
            substringSearch,
            '!isNil(metadata.auto.lastvisit)',
            'metadata.auto.lastvisit >= dateAdd(startOfPeriod("daily", now()), -30, "days")',
        );
};

export default {
    name: 'MentionsVisitorSearchAggregation',
    productArea: PRODUCT_AREAS.ASK_PENDO,
    subProductArea: SUB_PRODUCT_AREAS.AGENT_MODE_MENTIONS,
    responseFormat: 'rows',
    build: ({ query, showInactive }: { query: string, showInactive: boolean }) => {
        return o.pipeline(
            o.sources.visitors({ blacklist: 'apply' }),
            o.identified('visitorId'),
            o.filter(buildFilterString(query, showInactive)),
            o.limit(100),
            o.select({
                id: 'visitorId',
                name: 'metadata.agent.full_name',
                email: 'metadata.agent.email',
            }),
        );
    },
};